import { useEffect, useState } from 'react';
import { Flex } from 'components/base/layout-components';
import styled from 'styled-components';
import {
  isGdprCookieExists,
  removeIsGdprCheckboxChecked,
  storeIsGdprCheckboxChecked
} from 'common/services/gdpr.service';
import Text from 'components/base/Text';
import { Checkbox } from '@linearb/linui-common/marketing/Checkbox';
import { Link } from '@linearb/linui-common/marketing/Link';
import { PRIVACY_POLICY_LINK, TERMS_LINK } from 'common/constants/constants';

const GdprConsentAgreementWrapper = styled(Flex)`
  font-size: 1rem;
  line-height: 1.5rem;

  & p {
    line-height: 1.5rem;
  }
`;

const NeverAgreedBefore = ({ onChange }) => {
  const [isCheck, setIsCheck] = useState(false);

  const onCheckboxChange = e => {
    const isCheckedValue = e.target.checked;
    if (isCheckedValue) {
      storeIsGdprCheckboxChecked();
    } else {
      removeIsGdprCheckboxChecked();
    }
    setIsCheck(isCheckedValue);
    onChange(isCheckedValue);
  };

  useEffect(() => {
    removeIsGdprCheckboxChecked();
  }, []);

  return (
    <Checkbox
      onClick={onCheckboxChange}
      checked={isCheck}
      inputProps={{ 'data-cy': 'gdpr-checkbox' }}
      sx={{ marginX: '5rem' }}
      label={
        <>
          I Agree to LinearB's Storage And Processing Of My Personal Data And To
          The{' '}
          <Link
            hideChevron
            sx={{ display: 'inline', fontSize: '1rem' }}
            href={TERMS_LINK}
            target='_blank'
            rel='noreferrer'
          >
            Terms Of Service
          </Link>{' '}
          And{' '}
          <Link
            hideChevron
            sx={{ display: 'inline', fontSize: '1rem' }}
            href={PRIVACY_POLICY_LINK}
            target='_blank'
            rel='noreferrer'
          >
            Privacy Policy
          </Link>
        </>
      }
    />
  );
};

const AgreedAlready = () => (
  <Text color='gray' weight='400'>
    By Continuing, You Agree To Our{' '}
    <Link
      hideChevron
      sx={{ display: 'inline', fontSize: '1rem' }}
      href={TERMS_LINK}
      target='_blank'
      rel='noreferrer'
    >
      Terms Of Service
    </Link>{' '}
    And{' '}
    <Link
      hideChevron
      sx={{ display: 'inline', fontSize: '1rem' }}
      href={PRIVACY_POLICY_LINK}
      target='_blank'
      rel='noreferrer'
    >
      Privacy Policy
    </Link>
  </Text>
);

const GdprConsentAgreement = ({ onChange, onInit }) => {
  const [isGdpr, setIsGdpr] = useState(false);

  const loadIsGdprCookie = () => {
    const isGdprCookie = isGdprCookieExists();
    setIsGdpr(isGdprCookie);
    onInit?.(isGdprCookie);
  };

  useEffect(() => {
    loadIsGdprCookie();
  }, []);

  return (
    <GdprConsentAgreementWrapper>
      {isGdpr ? <AgreedAlready /> : <NeverAgreedBefore onChange={onChange} />}
    </GdprConsentAgreementWrapper>
  );
};

export default GdprConsentAgreement;
